exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#fl_inp[data-v-e7f1d0e6] {\n    display:none;\n}\n.fl_upld label[data-v-e7f1d0e6] {\n    cursor: pointer;\n    padding: 10px 25px;\n    color: #F5B821;\n    text-align: center;\n}\n", ""]);

// exports
